import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from 'components/Container';

const BatteryHero = () => {
  return (
    <Box
      paddingTop={'16vh'}
      minHeight={300}
      height={'auto'}
      position={'relative'}
      sx={{
        backgroundColor: '#113d88',
        zIndex: 2,
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          width: 1,
          height: 1,
          background:
            'url(https://cdn.akygacomponents.com/foto/cat/akygabattery_background2.png) no-repeat center',
          backgroundSize: 'contain',
          zIndex: -1,
        }}
      />
      <Container position={'relative'} zIndex={2}>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          textAlign="center"
          minHeight="100%"
        >
          <Box marginBottom={4} />
        </Box>
        <Typography
          variant="h4"
          gutterBottom
          paddingLeft={'40vw'}
          sx={{
            fontWeight: 700,
            color: 'common.white',
          }}
        />
      </Container>
    </Box>
  );
};

export default BatteryHero;
